import styled from 'styled-components';

export const Content = styled.div`
  // padding: 20px 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

export const Title = styled.h2`
  font-size: 34px;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: -0.02em;
  text-align: left;
  color: var(--primary-dark-two);
  margin: 0px 0;
`;

export const Name = styled.h3`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.02em;
  text-align: left;
  color: #0a214280;
`;

export const Div = styled.div``;

export const Icon = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--primary-green);
  line-height: 0;
  border-radius: 40px;
`;

export const Head = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
`;

export const SwitchTitle = styled.h3`
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  margin: 0;
`;

export const Body = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  gap: 0.5rem;
  width: 100%;
  height: 100%;
  overflow: auto;
  margin-top: 1rem;
  padding-bottom: 1rem;
  padding-right: 0.4rem;

  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: #e1dfec;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-corner {
    background: #f1f1f1;
  }
`;

export const Uploader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  width: 76px;
  height: 76px;
`;

export const FormHeaderContainer = styled.div`
  display: flex;
  align-items: start;
  gap: 2rem;
  width: 100%;
`;

export const FormHeader = styled.div`
  display: flex;
  align-items: start;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  input[name='ar-title'] {
    direction: rtl;
    text-align: right;
  }
`;
